const queryParameters = new URLSearchParams(window.location.search)

export function query_color(name: string, defvalue: string): string {
    let color = queryParameters.get(name);
    if (!color) {
        return defvalue;
    }
    if (color.startsWith('#')) {
        color = color.substring(1);
    }
    if (!color.match(/^(?:[0-9a-f]{3}){1,2}$/i)) {
        return defvalue;
    }
    return color
}

export function query_number(name: string, defvalue: number, min: number, max: number): number {
    let num = queryParameters.get(name);
    if (!num || window.isNaN(window.parseFloat(num))) {
        return defvalue;
    }
    const f = window.parseFloat(num);
    if (f < min) {
        return min;
    }
    if (f > max) {
        return max;
    }
    return f;
}

export function query_boolean(name: string, defvalue: boolean = false): boolean {
    return queryParameters.get(name) == "true" || defvalue;
}

export function query_string(name: string, defvalue: string = "", allowedValues: string[] = []): string {
    const tmp = queryParameters.get(name);
    return (tmp && ((allowedValues.length == 0) || (allowedValues.indexOf(tmp) >= 0)) && tmp) || defvalue;
}
